<template>
  <PresentLevelsHeader 
    title="Present Levels Wizard"
    subtitle="Use the wizard to identify specific areas of strengths or needs for an individual student."
  />
  <div class="flex flex-col">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import AIDisclaimer from '@/components/AIDisclaimer.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import PresentLevelsHeader from '@/presentlevels/PresentLevelsHeader.vue'

getAnalyticsTracker().getChildContext({
  plw_is_library: false
})
</script>
